module.exports = __webpack_public_path__ + "img/otras-mascotas.4292abc2.svg";